<template>
  <div class="realtime-page">
    <div class="top-nav-wrapper">
      <div class="toggle-container">
        <div class="toggle-item" :class="{active: viewMode === 'map'}" @click="viewMode = 'map'">地图</div>
        <div class="toggle-item" :class="{active: viewMode === 'list'}" @click="viewMode = 'list'">列表</div>
      </div>
      <i class="el-icon-search search-icon" @click="showSearch = !showSearch"></i>
    </div>

    <div class="station-selector" @click="showStationPopup = true">
      <div class="station-name">{{ currentStationName || '选择场站' }}</div>
      <i class="el-icon-sort rotate-90"></i>
    </div>

    <div class="status-filter-bar">
      <div class="filter-item" :class="{active: filterStatus === ''}" @click="filterStatus = ''">
        <div class="count">{{ statusCounts.all }}</div>
        <div class="label">全部</div>
      </div>
      <div class="filter-item" :class="{active: filterStatus === '0'}" @click="filterStatus = '0'">
        <div class="count">{{ statusCounts.free }}</div>
        <div class="label">空闲</div>
      </div>
      <div class="filter-item" :class="{active: filterStatus === '1'}" @click="filterStatus = '1'">
        <div class="count">{{ statusCounts.charging }}</div>
        <div class="label">充电</div>
      </div>
      <div class="filter-item" :class="{active: filterStatus === '2'}" @click="filterStatus = '2'">
        <div class="count">{{ statusCounts.yuyue }}</div>
        <div class="label">预约</div>
      </div>
      <div class="filter-item" :class="{active: filterStatus === '3'}" @click="filterStatus = '3'">
        <div class="count">{{ statusCounts.qidong }}</div>
        <div class="label">启动</div>
      </div>
      <div class="filter-item" :class="{active: filterStatus === '05'}" @click="filterStatus = '5'">
        <div class="count">{{ statusCounts.guzhang }}</div>
        <div class="label">故障</div>
      </div>
      <div class="filter-item" :class="{active: filterStatus === '10'}" @click="filterStatus = '10'">
        <div class="count">{{ statusCounts.shibai }}</div>
        <div class="label">失败</div>
      </div>
    </div>

    <div class="gun-list" v-loading="loading">
      <div class="gun-card" v-for="(item, index) in filteredGunList" :key="index" @click="showGunDetail(item)">
        <div class="gun-info">
          <div class="gun-code">{{ item.realName }}{{ item.name }}</div>
          <div class="gun-status" :class="getStatusClass(item)">{{ getStatusText(item) }}</div>
        </div>
        <div class="gun-image">
          <div class="illus-bg" :class="getStatusBgClass(item)">
            <img src="@/assets/image/gun.png" alt="gun" />
          </div>
        </div>
      </div>
      <div class="empty-tip" v-if="!loading && filteredGunList.length === 0">
        <i class="el-icon-s-order"></i>
        <p>暂无数据</p>
      </div>
    </div>

    <el-dialog
      title="选择场站"
      :visible.sync="showStationPopup"
      width="100%"
      custom-class="bottom-dialog station-dialog"
      :show-close="true"
    >
      <div class="station-content">
        <el-input placeholder="输入场站名称" prefix-icon="el-icon-search" v-model="searchKey" clearable></el-input>
        <div class="station-list">
          <div class="station-item" :class="{active: currentStationId === null}" @click="selectStation(null, '全部场站')">
            <div class="s-info">
              <p class="name"><i class="el-icon-office-building"></i> 全部场站</p>
            </div>
            <i class="el-icon-success" v-if="currentStationId === null"></i>
            <span class="uncheck" v-else></span>
          </div>
          <div class="station-item" :class="{active: currentStationId === item.id}" v-for="item in filteredStations" :key="item.id" @click="selectStation(item.id, item.plotName)">
            <div class="s-info">
              <p class="name"><i class="el-icon-school"></i> {{ item.plotName }}</p>
              <p class="sub">{{ item.address || '' }}</p>
            </div>
            <i class="el-icon-success" v-if="currentStationId === item.id"></i>
            <span class="uncheck" v-else></span>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="端口详情"
      :visible.sync="showDetailPopup"
      width="90%"
      custom-class="detail-dialog"
    >
      <div class="gun-detail" v-if="selectedGun">
        <div class="detail-header">
          <div class="detail-status" :class="getStatusClass(selectedGun.gunStatus)">{{ getStatusText(selectedGun.gunStatus) }}</div>
          <div class="detail-code">{{ selectedGun.deviceid || selectedGun.name }}</div>
        </div>
        <div class="detail-info">
          <div class="info-row">
            <span class="label">端口编号</span>
            <span class="value">{{ selectedGun.deviceid || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">充电桩编号</span>
            <span class="value">{{ selectedGun.parkid || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="label">枪口状态</span>
            <span class="value" :class="getStatusClass(selectedGun.gunStatus)">{{ getStatusText(selectedGun.gunStatus) }}</span>
          </div>
          <div class="info-row">
            <span class="label">是否可用</span>
            <span class="value">{{ selectedGun.canUse === 1 ? '可用' : '不可用' }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agentPlotList, getPortListByStation, getPortList } from "@/api/newApi";

export default {
  name: 'RealtimeList',
  data() {
    return {
      viewMode: 'list',
      showSearch: false,
      showStationPopup: false,
      showDetailPopup: false,
      searchKey: '',
      currentStationId: null,
      currentStationName: '全部场站',
      stationList: [],
      gunList: [],
      filterStatus: '',
      selectedGun: null,
      loading: false,
      statusMap: {
        '0': { text: '空闲', class: 'green', bg: 'bg-green' },
        '1': { text: '充电', class: 'blue', bg: 'bg-blue' },
        '2': { text: '预约', class: 'dark', bg: 'bg-dark' },
        '3': { text: '正在启动充电', class: 'orange', bg: 'bg-orange' },
        '5': { text: '充电故障', class: 'red', bg: 'bg-red' },
        '10': { text: '启动失败', class: 'gray', bg: 'bg-gray' }
      }
    };
  },
  computed: {
    filteredStations() {
      if (!this.searchKey) return this.stationList;
      return this.stationList.filter(s => 
        s.plotName && s.plotName.toLowerCase().includes(this.searchKey.toLowerCase())
      );
    },
    filteredGunList() {
      if (!this.filterStatus) return this.gunList;
      return this.gunList.filter(g => String(g.gunStatus) === this.filterStatus);
    },
    statusCounts() {
      const counts = { all: this.gunList.length, free: 0, charging: 0, yuyue: 0, qidong: 0, guzhang: 0, shibai: 0 };
      this.gunList.forEach(g => {
        const status = String(g.gunStatus);
        if (status === '0') counts.free++;
        else if (status === '1') counts.charging++;
        else if (status === '2') counts.yuyue++;
        else if (status === '3') counts.qidong++;
        else if (status === '5') counts.guzhang++;
        else if (status === '10') counts.shibai++;
      });
      return counts;
    }
  },
  mounted() {
    this.getStationList();
    this.getPortList();
  },
  methods: {
    async getStationList() {
      try {
        const res = await agentPlotList({});
        if (res.data && res.data.length > 0) {
          this.stationList = res.data;
        }
      } catch (err) {
        console.log('获取场站列表失败', err);
      }
    },
    async getPortList() {
      this.loading = true;
      try {
        let res;
        if (this.currentStationId) {
          res = await getPortListByStation(this.currentStationId, { pageNo: 1, pageSize: 100 });
        } else {
          res = await getPortList({ pageNo: 1, pageSize: 500 });
        }
        if (res.data && res.data.records) {
          this.gunList = res.data.records;
        } else if (res.data && Array.isArray(res.data)) {
          this.gunList = res.data;
        } else {
          this.gunList = [];
        }
      } catch (err) {
        console.log('获取端口列表失败', err);
        this.gunList = [];
      } finally {
        this.loading = false;
      }
    },
    selectStation(id, name) {
      this.currentStationId = id;
      this.currentStationName = name;
      this.showStationPopup = false;
      this.getPortList();
    },
    showGunDetail(item) {
      this.selectedGun = item;
      this.showDetailPopup = true;
    },
    getStatusText(item) {
      const status = this.getGunStatus(item);
      const s = this.statusMap[String(status)];
      if (s) return s.text;
      const stateText = this.getStateText(item);
      return stateText === '未知' ? '空闲' : stateText;
    },
    getStatusClass(item) {
      const status = this.getGunStatus(item);
      const s = this.statusMap[String(status)];
      return s ? s.class : 'gray';
    },
    getStatusBgClass(item) {
      const status = this.getGunStatus(item);
      const s = this.statusMap[String(status)];
      return s ? s.bg : 'bg-gray';
    },
    getGunStatus(item) {
      if (item.gunStatus !== undefined && item.gunStatus !== null) {
        return item.gunStatus;
      }
      if (item.state === 'N') return 2;
      if (item.state === 'Y') return 3;
      if (item.canUse === 1) return 2;
      if (item.canUse === 0) return 1;
      return null;
    },
    getStateText(item) {
      if (item.state === 'N') return '空闲';
      if (item.state === 'Y') return '占用';
      return '空闲';
    }
  }
};
</script>

<style lang="scss" scoped>
.realtime-page {
  background-color: #F4F9F9;
  min-height: 100vh;
  font-family: "PingFang SC", sans-serif;
}

.top-nav-wrapper {
  padding: 10px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #FFF;
  .toggle-container {
    display: flex;
    background: #F0F2F5;
    border-radius: 20px;
    overflow: hidden;
    .toggle-item {
      padding: 6px 24px;
      font-size: 14px;
      color: #666;
      &.active {
        background: #2CC9E1;
        color: #FFF;
      }
    }
  }
  .search-icon {
    position: absolute;
    right: 16px;
    font-size: 22px;
    color: #333;
  }
}

.station-selector {
  background: #FFF;
  margin: 10px 16px;
  padding: 12px 15px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.02);
  .station-name {
    font-size: 15px;
    font-weight: bold;
    color: #333;
  }
  .rotate-90 {
    transform: rotate(90deg);
    color: #666;
    font-size: 14px;
  }
}

.status-filter-bar {
  display: flex;
  padding: 10px 16px;
  gap: 8px;
  overflow-x: auto;
  &::-webkit-scrollbar { display: none; }
  
  .filter-item {
    flex: 0 0 65px;
    background: #FFF;
    padding: 10px 0;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid transparent;
    
    .count { font-size: 18px; font-weight: bold; color: #333; }
    .label { font-size: 12px; color: #999; margin-top: 4px; }
    
    &.active {
      background: #2CC9E1;
      .count, .label { color: #FFF; }
    }
  }
}

.gun-list {
  padding: 10px 16px;
  min-height: 300px;
  .gun-card {
    background: #FFF;
    border-radius: 12px;
    padding: 20px 15px;
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 10px rgba(0,0,0,0.02);
    
    .gun-info {
      .gun-code {
        font-size: 14px;
        color: #BBB;
        margin-bottom: 15px;
      }
      .gun-status {
        font-size: 16px;
        font-weight: bold;
        &.green { color: #1BC48D; }
        &.blue { color: #4A81FF; }
        &.orange { color: #FF9546; }
        &.gray { color: #999; }
        &.dark { color: #333; }
        &.yellow { color: #FFC107; }
        &.red { color: #FF0000; }
      }
    }
    
    .gun-image {
      width: 70px;
      height: 70px;
      position: relative;
      .illus-bg {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        &.bg-green { background: rgba(27, 196, 141, 0.15); }
        &.bg-blue { background: rgba(74, 129, 255, 0.15); }
        &.bg-orange { background: rgba(255, 149, 70, 0.15); }
        &.bg-gray { background: rgba(153, 153, 153, 0.15); }
        &.bg-dark { background: rgba(51, 51, 51, 0.1); }
        &.bg-yellow { background: rgba(255, 193, 7, 0.15); }
        &.bg-red { background: rgba(255, 0, 0, 0.15); }
        img { width: 45px; transform: rotate(-15deg); }
      }
    }
  }
  .empty-tip {
    text-align: center;
    padding: 40px 0;
    color: #999;
    i { font-size: 48px; margin-bottom: 10px; }
    p { font-size: 14px; }
  }
}

.bottom-dialog {
  margin: 0 !important;
  position: fixed !important;
  bottom: 0;
  border-radius: 20px 20px 0 0 !important;
  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 20px; }
}

.station-dialog {
  .station-content {
    .el-input {
      margin-bottom: 15px;
    }
    .station-list {
      max-height: 400px;
      overflow-y: auto;
    }
    .station-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #f5f5f5;
      .name { font-weight: bold; font-size: 15px; i { color: #4A81FF; } }
      .sub { font-size: 12px; color: #999; margin-top: 5px; }
      .el-icon-success { color: #00BFA5; font-size: 20px; }
      .uncheck { width: 18px; height: 18px; border: 1px solid #ddd; border-radius: 50%; }
    }
  }
}

.detail-dialog {
  border-radius: 12px;
  .el-dialog__header { display: none; }
  .el-dialog__body { padding: 20px; }
  .gun-detail {
    .detail-header {
      text-align: center;
      margin-bottom: 20px;
      .detail-status {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 8px;
        &.green { color: #1BC48D; }
        &.blue { color: #4A81FF; }
        &.orange { color: #FF9546; }
        &.gray { color: #999; }
        &.dark { color: #333; }
        &.yellow { color: #FFC107; }
      }
      .detail-code {
        font-size: 14px;
        color: #666;
      }
    }
    .detail-info {
      .info-row {
        display: flex;
        justify-content: space-between;
        padding: 12px 0;
        border-bottom: 1px solid #f5f5f5;
        .label { color: #999; font-size: 14px; }
        .value { color: #333; font-size: 14px; }
      }
    }
  }
}
</style>